import React from 'react';
import { Tab, TabBar } from '../ui/Tab';
import { Link, useLocation } from 'react-router-dom';

interface TabItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  path: string;
}

const tabs: TabItem[] = [
  { id: 'dashboard', label: 'Dashboard', icon: '📊', path: '/dashboard' },
  { id: 'coach', label: '222Coach', icon: '✦', path: '/coach' },
  { id: 'insights', label: 'Insights', icon: '💡', path: '/insights' },
  { id: 'blood', label: 'Blood', icon: '🩸', path: '/blood' },
  { id: 'weight', label: 'Weight', icon: '⚖️', path: '/weight' },
  { id: 'progress', label: 'Progress', icon: <span className="material-symbols-outlined">calendar_month</span>, path: '/progress' },
  { id: 'shop', label: 'Shop', icon: '🛒', path: '/shop' },
  { id: 'profile', label: 'Profile', icon: '👤', path: '/profile' },
];

export function TopNav() {
  const location = useLocation();

  return (
    <TabBar>
      {tabs.map((tab) => (
        <Link
          key={tab.id}
          to={tab.path}
          className={`
            flex-1 flex flex-col items-center justify-center gap-1.5 py-3 transition-colors
            ${location.pathname === tab.path || (location.pathname === '/' && tab.path === '/dashboard') ? 'text-primary' : 'text-on-surface-variant'}
          `}
        >
          <span className="text-lg">{tab.icon}</span>
          <span className="text-xs font-medium">{tab.label}</span>
          {location.pathname === tab.path || (location.pathname === '/' && tab.path === '/dashboard') ? (
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" />
          ) : null}
        </Link>
      ))}
    </TabBar>
  );
}
